import { AfterContentChecked, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Structure } from "../../models/structure.model";
import { StructureService } from "../../services/structure.service";
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements AfterContentChecked {
  public isLoggedIn = false;
  structure?: Structure;

  /* constructor( private router: Router ) {
      this.router.events.subscribe(event => {
         if (event instanceof NavigationEnd) {
            if(event.url==='/admin') {}
         }
      })
     }
  */

  constructor(
    private readonly keycloak: KeycloakService,
    private ss: StructureService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  async ngOnInit() {
    let isLoggedIn = await this.keycloak.isLoggedIn();
    // console.log(this.route.snapshot);
    //this.route.url.subscribe(console.log); // UrlSegment[]
    this.route.url.subscribe((event) => {
      let segment1 = event[0].path
      event.forEach((segment) => {
        //console.log( segment ); //.path .parameters
      });
      if (segment1 === 'login') {
        // check the access token else the Keycloak
        this.keycloak.login();
      } else {

        if (segment1 === environment.adminPath) {
          if (!isLoggedIn) this.keycloak.login();
        }

        const relativePath = event.map(segment => segment.path).join('/');
        const editIndex = relativePath.indexOf("/edit");
        let finalPath = editIndex !== -1
          ? relativePath.substring(relativePath.indexOf(segment1), editIndex)
          : relativePath;

        const prefixCreate = "create";
        const prefixEdit = "edit";

        if (event.at(-1)?.path === prefixCreate) {
          finalPath = finalPath.replace(prefixCreate, prefixEdit + "-" + event.at(-2)?.path);
        } else if (event.at(-2)?.path === prefixEdit) {
          finalPath = finalPath + "/" + prefixEdit + "-" + event.at(-3)?.path;
        }

        this.ss.getLayout(finalPath, window.location.hostname).subscribe(structure => this.structure = structure);
        //this.ss.getLayoutFile(segment1).subscribe(structure => this.structure = structure);
        // verifica la protezione della pagina ed eventualmente redirige al login
      }
    });
  }

  getLayout() {
    return this.structure?.data?.layout;
  }

  getHeader() {
    return this.structure?.data?.frames?.find(frame => frame.name === 'header');
  }

  getNav() {
    return this.structure?.data?.frames?.find(frame => frame.name === 'sidebar');
  }

  getMain() {
    return this.structure?.data?.frames?.find(frame => frame.name === 'main');
  }

  getFooter() {
    return this.structure?.data?.frames?.find(frame => frame.name === 'footer');
  }

}
